<template lang='pug' src='./Navbar.pug'></template>

<script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import router from '../../router'

  export default {
    name: 'Navbar',
    data: function () {
      return {
        showOptions: false
      }
    },
    props: {
      admin: Boolean
    },
    computed: {
      ...mapGetters([
        'getMe',
        'isAdmin'
      ])
    },
    mounted () {
      document.addEventListener('click', this.onClick)
    },
    beforeDestroy () {
      document.removeEventListener('click', this.onClick)
    },
    methods: {
      onClick: function (ev) {
        if (!this.$el.contains(ev.target)) {
          this.showOptions = false
        }
      },
      logout: function () {
        return window.fetch(Vue.config.holidays.LOGOUT)
          .then(response => {
            if (response.status === 200) {
              router.push({ name: 'login' })
            }
          })
          .catch(() => router.push({ name: '404' }))
      }
    }
  }
</script>

<style lang='css' src='./Navbar.css' scoped></style>



// WEBPACK FOOTER //
// Navbar.vue?4fea7f8d